import { render, staticRenderFns } from "./PreventFoolExample.vue?vue&type=template&id=7a5797db&scoped=true"
import script from "./PreventFoolExample.vue?vue&type=script&lang=js"
export * from "./PreventFoolExample.vue?vue&type=script&lang=js"
import style0 from "./PreventFoolExample.vue?vue&type=style&index=0&id=7a5797db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5797db",
  null
  
)

export default component.exports